import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../services/api";
import { currencyMask } from "../../../utils/masks";
import { toast } from "react-toastify";
import toastOptions from "../../../utils/toastOptions";

type RouteParams = {
  type: string;
}

export default function OrderSummary() {
  const params = useParams<RouteParams>();
  const [summary, setSummary] = useState<any>({ totalItems: 0, itemsBySize: {} });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSummary();
  }, [params.type]);

  const fetchSummary = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`orders/${params.type}/stats`);
      setSummary({
        totalItems: data.totalItems,
        itemsBySize: data.itemsBySize,
        totalAmountDue: data.totalAmountDue,
        totalPaid: data.totalPaid
      });
    } catch (e: any) {
        e.messages?.forEach((m: string) => toast.warning(m, toastOptions));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="page-order-summary">
      <div className="uk-card uk-card-default uk-card-body">
        <div className="uk-flex uk-flex-between uk-flex-middle uk-margin-bottom">
          <h3 className="uk-card-title uk-margin-remove">Resumo de Pedidos • {params.type?.toUpperCase()}</h3>
          <div>
            <Link to={`/pedidos/${params.type}/lotes`} className="uk-button uk-button-primary uk-button-small uk-margin-small-right">Lotes</Link>
            <Link to={`/pedidos/${params.type}`} className="uk-button uk-button-default uk-button-small">Voltar</Link>
          </div>
        </div>

        {loading ? (
          <div className="uk-flex uk-flex-center" uk-spinner="ratio: 2"></div>
        ) : (<>
          <div className="uk-grid-small uk-width-1-1@m uk-child-width-1-1@s" uk-grid="true">
            <div className="uk-width-1-2@m">
              <div className="uk-card uk-card-primary uk-card-body">
                <h1 className="uk-card-title uk-margin-remove uk-text-center">{summary.totalItems || 0}</h1>
                <p className="uk-text-center uk-text-large uk-margin-remove">Total de Itens</p>
              </div>
            </div>
            <div className="uk-width-1-4@m">
              <div className="uk-card uk-card-secondary uk-card-body" style={{background: 'linear-gradient(135deg, #66d0eaff 0%, #4b6ea2ff 100%)', color: 'white'}}>
                <h1 className="uk-card-title uk-margin-remove uk-text-center">{currencyMask(summary.totalAmountDue?.toFixed(2) || 0)}</h1>
                <p className="uk-text-center uk-text-large uk-margin-remove">Valor</p>
              </div>
            </div>
            <div className="uk-width-1-4@m">
              <div className="uk-card uk-card-success uk-card-body" style={{background: 'linear-gradient(135deg, #66d0eaff 0%, #4b6ea2ff 100%)', color: 'white'}}>
                <h1 className="uk-card-title uk-margin-remove uk-text-center">{currencyMask(summary.totalPaid?.toFixed(2) || 0)}</h1>
                <p className="uk-text-center uk-text-large uk-margin-remove">Recebido</p>
              </div>
            </div>
          </div>
          <div className="uk-grid-small uk-width-1-1@m uk-child-width-1-1@s" uk-grid="true">
            {summary.itemsBySize && Object.keys(summary.itemsBySize).length > 0 && (
              <div>
                <div className="uk-card uk-card-default uk-card-body" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white'}}>
                  <h4 className="uk-margin-remove uk-margin-bottom uk-text-bold" style={{color: 'white'}}>Itens</h4>
                  <ul className="uk-list uk-list-divider uk-margin-remove">
                    {Object.entries(summary.itemsBySize)
                      .map(([detail, count]: [string, any]) => (
                        <li key={detail} className="uk-flex uk-flex-between uk-padding-remove">
                          <span>{detail}</span>
                          <span>{count}</span>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </>
        )}
      </div>
    </div>
  );
}
